import type { Canvas } from "fabric";
import {
  type BaseCanvasState,
  createCanvasStore,
} from "../../../../components/FabricCanvas/canvasStoreFactory.ts";

export type FillMode = "brush" | "lasso";

type GenerativeFillCanvasState = BaseCanvasState & {
  fillMode: FillMode;
  brushSize: number;
};

type GenerativeFillCanvasActions = {
  setFillMode: (fillMode: FillMode) => void;
  setBrushSize: (brushSize: number) => void;
  clearObjects: () => void;
};

export const generativeFillCanvasStore = createCanvasStore<
  GenerativeFillCanvasState,
  GenerativeFillCanvasActions
>(
  {
    fabricCanvas: undefined as Canvas | undefined,
    fillMode: "brush" as FillMode,
    brushSize: 90 as number,
    isDrawingMode: true,
    isDeletionDisabled: false,
  },
  ({ get, setter, set }) => {
    const clearObjects = () => {
      const fabricCanvas = get().fabricCanvas;
      if (!fabricCanvas) return;
      const allObjects = fabricCanvas.getObjects();
      if (allObjects.length > 0) fabricCanvas.remove(...allObjects);
    };
    return {
      setFillMode: (fillMode: FillMode) => {
        if (get().fillMode !== fillMode) {
          const fabricCanvas = get().fabricCanvas;
          if (fabricCanvas) clearObjects();
          set({
            fillMode,
          });
        }
      },
      setBrushSize: setter("brushSize"),
      clearObjects,
    };
  },
);
